export { Photograph as default } from './Photograph';
